module.exports = __webpack_public_path__ + "static/media/pg_table_beaker_highlight.305a4141.svg";